import { Main } from "./Pages/Main/Main";

function App() {
  return (
    <Main/>
  );
}

export default App;